<template>
  <div class="exam-content-hiw">
    <div class="title">
      You will hear a recording. Below is a transcription of the recording. Some
      words in the transcription differ from what the speaker said. Please click
      on the words that are different.
    </div>
    <div class="body">
      <div class="audio">
        <Audio :url="detail.audio.url" />
      </div>
      <div class="content">
        <span
          v-for="(item, index) of disposeContent"
          :key="`${index}_${item.text}`"
          :class="[
            { select: selectIndex.includes(index) },
            item.truth || selectIndex.includes(index)
              ? item.text === item.truth
                ? 'green'
                : 'red'
              : ''
          ]"
          @click="handleSelect(index)"
        >
          {{ item.text }}
          <span v-if="item.truth" class="right-word">({{ item.truth }})</span>
        </span>
      </div>
    </div>

    <Score :info="examInfo" :detail="detail" />
  </div>
</template>

<script>
import api from '@/api/exam'
import Audio from '../../components/audio'
import Score from '../../components/score'

export default {
  components: {
    Audio,
    Score
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectIndex: []
    }
  },
  computed: {
    disposeContent() {
      return JSON.parse(this.examInfo.dispose_content || '[]')
    }
  },
  mounted() {
    this.selectIndex = this.examInfo.user_answer
      .split(',')
      .map((word) => this.disposeContent.findIndex((m) => m.text === word))
  },
  methods: {
    submit() {
      this.handleSave()
      return true
    },
    async handleSave() {
      await api.submit({
        my_exam_id: this.examInfo.my_exam_id,
        qid: this.itemData.gre_try_id,
        contents: this.selectIndex
      })
      this.onFinish()
    },

    handleSelect(index) {
      if (this.selectIndex.includes(index)) {
        this.selectIndex = this.selectIndex.filter((m) => m !== index)
      } else {
        this.selectIndex = this.selectIndex.concat([index])
      }
    }
  }
}
</script>

<style scoped lang="scss">
.exam-content-hiw {
  color: #1f1f40;
  .title {
    margin-top: 24px;
    font-size: 16px;
    font-weight: bold;
  }
  .body {
    margin: 0 auto;
  }
  pre {
    margin-top: 24px;
    font-size: 18px;
    line-height: 32px;
    word-break: break-word;
    word-spacing: normal;
    white-space: pre-wrap;
  }
  .ipt {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .audio {
    margin-top: 14px;
    display: flex;
    justify-content: center;
  }
  .content {
    margin-top: 24px;
    line-height: 20px;
    > span {
      cursor: pointer;
      &.green {
        color: #36c626;
      }
      &.red {
        color: #df394d;
      }
    }
    .select {
      background-color: #fff781;
    }
  }
  .right-word {
    color: #36c626;
  }
}
</style>
